import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';

import { PbsCookieNames, ReferralType } from '../../models';
import type { CookieStoreInfo } from '../../types';

export const useCookieStoreInfo = () => {
  const [cookieInfo, setCookieInfo] = useState<CookieStoreInfo>({
    type: ReferralType.None,
    productListType: 'Personal',
  });

  useEffect(() => {
    const pbsOwnerCookie = Cookies.get(PbsCookieNames.PBS_OWNER);
    const ecrefCookie = Cookies.get(PbsCookieNames.ECREF);

    if (pbsOwnerCookie) {
      setCookieInfo({
        owner: pbsOwnerCookie,
        productListType: 'Personal',
        type: ReferralType.PBS,
      });

      return;
    }

    if (ecrefCookie) {
      setCookieInfo({
        owner: ecrefCookie,
        productListType: 'Personal',
        type: ReferralType.ECREF,
      });
    }
  }, []);

  return cookieInfo;
};
